import { useEffect } from "react";
import { readPresenterSnapshot, WINDOW_PROTOCOL } from "./translationWindowProtocol";

// Popups may use a different storage partition from an embedded Dashboard.
// They register themselves, including after either side is refreshed.
export const useTranslationPresenter = () => {
  useEffect(() => {
    const clients = new Map();
    const origin = window.location.origin;
    const send = (client, force = false) => {
      try {
        if (client.source.closed || client.source.opener !== window) {
          clients.delete(client.source);
          return;
        }
        const snapshot = readPresenterSnapshot(client.windowId);
        const serialized = JSON.stringify(snapshot);
        if (!force && serialized === client.lastSent) return;
        client.source.postMessage({
          protocol: WINDOW_PROTOCOL, type: "snapshot", windowId: client.windowId, snapshot,
        }, origin);
        client.lastSent = serialized;
      } catch {
        clients.delete(client.source);
      }
    };
    const onMessage = (event) => {
      const data = event.data;
      if (event.origin !== origin || !event.source || !data || data.protocol !== WINDOW_PROTOCOL
          || data.type !== "request" || ![1, 2].includes(data.windowId)) return;
      try {
        const path = data.windowId === 1 ? "/translation" : "/translation2";
        if (event.source.opener !== window || event.source.location.pathname !== path) return;
        const client = clients.get(event.source) || { source: event.source, windowId: data.windowId };
        clients.set(event.source, client);
        send(client, true);
      } catch {
        // Ignore unrelated/cross-origin windows, even if the message shape matches.
      }
    };
    window.addEventListener("message", onMessage);
    // Also picks up captions from the system-test card without altering its flow.
    const interval = setInterval(() => clients.forEach(client => send(client)), 300);
    return () => {
      window.removeEventListener("message", onMessage);
      clearInterval(interval);
      clients.clear();
    };
  }, []);
};